import 'owa-bootstrap/lib/bootstrap'; // Important that owa-bootstrap come first, in order to bootstrap webpack settings
import 'owa-application'; // Import owa-application here to include globalStyles
import './mutators/displayedViewMutator';
import './orchestration/changeRoute';
import 'owa-calendar-module-selected-calendars-user-config';
import 'owa-attachment-preview-initialization/lib/utils/initializeAttachmentPreviewInPopOut';

export { getCalendarDeepLinkBootstrapOptions } from './routes/bootstrapDeepLink';
